/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_5_P1Inputs */

const en_terms_section_5_p1 = /** @type {(inputs: Terms_Section_5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything published on this website — text, graphics, logos, articles and design — belongs to Lindevo and is protected by copyright and related law.`)
};

const lv_terms_section_5_p1 = /** @type {(inputs: Terms_Section_5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viss, kas publicēts šajā tīmekļvietnē — teksts, grafika, logotipi, raksti un dizains — pieder Lindevo un ir aizsargāts ar autortiesībām un ar tām saistītajiem tiesību aktiem.`)
};

/**
* | output |
* | --- |
* | "Everything published on this website — text, graphics, logos, articles and design — belongs to Lindevo and is protected by copyright and related law." |
*
* @param {Terms_Section_5_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_5_p1 = /** @type {((inputs?: Terms_Section_5_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_5_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_5_p1(inputs)
	return en_terms_section_5_p1(inputs)
});